import { useEffect, useState } from "react";
import AdminSupport from "./Admin/AdminSupport";
import AgentSupport from "./Agent/AgentSupport";
import { isFieldAgent } from "../../utils/roleDetection";

const Support = () => {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;
	const roles = Array.isArray(user?.roles) ? user.roles : [];
	const isAgent = isFieldAgent(roles);

	return isAgent ? <AgentSupport /> : <AdminSupport />;
};
export default Support;
